<template>
  <div class="tile is-parent pl-1">
    <article class="tile is-child box">
      <table class="table is-bordered is-fullwidth access-restriction-table">
        <thead>
          <tr>
            <th>Day</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Full Access</th>
            <th>Denied Access</th>
            <th>Normal Access</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in sortedRestrictions"
            :key="item.id">
            <td class="access-day">{{ item.day.trim() }}</td>
            <td :class="timeCellClass(item)">
              <v-date-picker v-model="item.openTime"
                :is-dark="$theme.isDark"
                mode="time"
                :minute-increment="5"
                :masks="{ input: 'HH:mm' }"
                :disabled="item.isDeniedAccess || item.isFullAccess"
                :locale="$userInfo.locale"
                :timezone="$filters.getIanaTimezone()"
                class="is-fullwidth"
                @input="val => updateStartTime(item, val)">
                <template v-slot="{ inputValue, inputEvents }">
                  <div class="field has-addons">
                    <div class="control is-expanded has-icons-left">
                      <input type="text"
                        class="input"
                        placeholder="Start Time"
                        :value="inputValue"
                        v-on="inputEvents"
                        :class="timeCellClass(item)"
                        readonly
                        :disabled="item.isDeniedAccess || item.isFullAccess">
                      <span class="icon is-small is-left">
                        <span class="mso mso-18px">
                          event
                        </span>
                      </span>
                    </div>
                  </div>
                </template>
              </v-date-picker>
            </td>
            <td :class="timeCellClass(item)">
              <v-date-picker v-model="item.closeTime"
                :is-dark="$theme.isDark"
                mode="time"
                :minute-increment="5"
                :masks="{ input: 'HH:mm' }"
                :disabled="item.isDeniedAccess || item.isFullAccess"
                :locale="$userInfo.locale"
                :timezone="$filters.getIanaTimezone()"
                class="is-fullwidth"
                @input="val => updateEndTime(item, val)">
                <template v-slot="{ inputValue, inputEvents }">
                  <div class="field has-addons">
                    <div class="control is-expanded has-icons-left">
                      <input type="text"
                        class="input"
                        placeholder="End Time"
                        :value="inputValue"
                        v-on="inputEvents"
                        :class="timeCellClass(item)"
                        readonly
                        :disabled="item.isDeniedAccess || item.isFullAccess">
                      <span class="icon is-small is-left">
                        <span class="mso mso-18px">
                          event
                        </span>
                      </span>
                    </div>
                  </div>
                </template>
              </v-date-picker>
            </td>
            <td class="has-text-centered">
              <input type="radio"
                :name="`access-${item.day}`"
                v-model="accessType[item.id]"
                value="full"
                @change="setAccess(item, 'full')" />
            </td>
            <td class="has-text-centered">
              <input type="radio"
                :name="`access-${item.day}`"
                v-model="accessType[item.id]"
                value="denied"
                @change="setAccess(item, 'denied')" />
            </td>
            <td class="has-text-centered">
              <input type="radio"
                :name="`access-${item.day}`"
                v-model="accessType[item.id]"
                value="normal"
                @change="setAccess(item, 'normal')" />
            </td>
          </tr>
        </tbody>
      </table>
    </article>
  </div>
</template>

<script>
export default {
  name: 'UserAccessRestriction',
  props: {
    value: null
  },
  data() {
    return {
      accessType: {}
    }
  },
  computed: {
    sortedRestrictions() {
      return (this.value?.userAccessRestrictions || []).slice().sort((a, b) => a.sortIndex - b.sortIndex)
    }
  },
  watch: {
    'value.userAccessRestrictions': {
      handler(newVal) {
        if (!newVal) return
        newVal.forEach((item) => {
          if (item.isFullAccess) this.$set(this.accessType, item.id, 'full')
          else if (item.isDeniedAccess) this.$set(this.accessType, item.id, 'denied')
          else this.$set(this.accessType, item.id, 'normal')
        })
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    setAccess(item, type) {
      item.isFullAccess = type === 'full'
      item.isDeniedAccess = type === 'denied'
      if (type === 'normal') {
        item.isFullAccess = false
        item.isDeniedAccess = false
      }
    },
    timeCellClass(item) {
      if (item.isDeniedAccess) return 'access-time-red'
      if (item.isFullAccess) return 'access-time-green'
      return ''
    },
    toPickerDate(val) {
      if (!val) return null
      const [h, m] = val.slice(0, 5).split(':')
      const d = new Date()
      d.setHours(Number(h), Number(m), 0, 0)
      return d
    },
    fromPickerDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const h = String(d.getUTCHours()).padStart(2, '0')
      const m = String(d.getUTCMinutes()).padStart(2, '0')
      return `${h}:${m}:00`
    },
    updateStartTime(item, val) {
      item.startTime = this.fromPickerDate(val)
    },
    updateEndTime(item, val) {
      item.endTime = this.fromPickerDate(val)
    }
  }
}
</script>

<style scoped>
.access-restriction-table th,
.access-restriction-table td {
  vertical-align: middle;
  text-align: center;
}
.access-day {
  font-weight: bold;
  text-align: left;
}
.access-time-green {
  background-color: #218838 !important;
  color: #fff;
}
.access-time-red {
  background-color: #dc3545 !important;
  color: #fff;
}
:global(.vc-time-picker .vc-date) {
  display: none;
}
</style>